import { useCallback, useState } from "react";
import { useDebounce } from "./useDebounce";

// Ô tìm kiếm của thanh công cụ bảng: giá trị gõ ngay, giá trị dùng để gọi API được trì hoãn 400ms
export const useSearchInput = (delay = 400) => {
  const [value, setValue] = useState("");
  const debounced = useDebounce(value, delay);

  const clear = useCallback(() => setValue(""), []);

  return { value, debounced, onChange: setValue, clear };
};
